package pt.at.oss.kotlin.manual.validator.common

import pt.at.oss.kotlin.core.enumeration.MemberState
import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants
import kotlin.text.replace
import kotlin.text.trim

val MOSS_PATTERN = Regex("[A-Z0-9+*]{1,12}")
fun validMossNum(vatIdNum: String): Boolean {
    return MOSS_PATTERN.matches(vatIdNum) &&
        !vatIdNum.startsWith("EU") &&
        !vatIdNum.startsWith("IM") &&
        !vatIdNum.startsWith("IN")
}
val VOES_PATTERN = Regex("EU([0-9]{3})[0-9]{6}")
fun validVoesNum(vatIdNum: String, country: MemberState): Boolean {
    val match = VOES_PATTERN.matchEntire(vatIdNum)
    val countryMatches = country.n3Code == match?.groupValues?.get(1)
    return match != null && countryMatches
}
val IOSS_PATTERN = Regex("IM([0-9]{3})[0-9]{7}")
fun validIossNum(vatIdNum: String, country: MemberState): Boolean {
    val match = IOSS_PATTERN.matchEntire(vatIdNum)
    val countryMatches = country.n3Code == match?.groupValues?.get(1)
    return match != null && countryMatches
}
val INT_PATTERN = Regex("IN([0-9]{3})[0-9]{7}")
fun validIntNum(vatIdNum: String, country: MemberState): Boolean {
    val match = INT_PATTERN.matchEntire(vatIdNum)
    val countryMatches = country.n3Code == match?.groupValues?.get(1)
    return match != null && countryMatches
}

fun validTaxRefNum(taxRefNum: String): Boolean {
    val trimmedAndSingleSpaces = taxRefNum.trim().replace(Regex("\\s+"), " ")
    return taxRefNum == trimmedAndSingleSpaces && taxRefNum.isNotEmpty() && taxRefNum.length <= FieldSizeConstants.TAX_REF_NUM_MAX_LEN
}
